export default {
  new_support_model: {
    contact_options: {
      support_options: {
        chat: {
          // description: 'Hablá con uno de nuestros representantes a través de nuestro chat en vivo.',
          description_sales:
            'Disponible de lunes a viernes de 10:00am a 2:00pm y de 4:00pm a 7:30pm',
          description_sales_acc:
            'Disponible de lunes a viernes de 10:00am a 2:00pm y de 4:00pm a 7:30pm',
          // description: 'Disponible de lunes a viernes de 9:00am a 2:30pm y de 4pm a 6:30pm',
          description: 'Disponible de lunes a viernes de 9:00am a 1:30pm y de 3pm a 6:30pm',
          description_acc: 'Disponible de lunes a viernes durante todo el día',
        },
        try_chat: {
          // description:'Chateá en vivo con nuestros representantes. ¡Probá gratis durante el primer mes!',
          description_sales:
            'Disponible de lunes a viernes de 10:00am a 2:00pm y de 4:00pm a 7:30pm',
          description:
            'Disponible de lunes a viernes de 9:00am a 1:30pm y de 3pm a 6:30pm <span style="color: #4F46E5;">¡Prueba gratis durante los primeros 15 días!</span>',
        },
        whatsapp: {
          title: 'Escríbenos por WhatsApp',
          // description: 'Obtén asistencia personalizada a través de WhatsApp.',
          description:
            'Obtén asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
          description_sales_acc:
            'Obtén asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 10:00am a 2:00pm y de 4:00pm a 7:30pm',
        },
      },
    },
  },
}
